document.addEventListener('DOMContentLoaded', function () {

  /* ── MOBILE MENU ── */
  var toggle = document.querySelector('.mobile-menu-btn');
  var navList = document.querySelector('.nav-list');
  if (toggle && navList) {
    toggle.addEventListener('click', function () {
      navList.classList.toggle('open');
    });
    // Chiude cliccando fuori
    document.addEventListener('click', function (e) {
      if (!toggle.contains(e.target) && !navList.contains(e.target)) {
        navList.classList.remove('open');
      }
    });
  }

  /* ── FAQ ACCORDION ── */
  document.querySelectorAll('.faq-item').forEach(function (el) {
    var q    = el.querySelector('.faq-q');
    var a    = el.querySelector('.faq-a');
    var icon = el.querySelector('.faq-icon');
    if (!q || !a) return;
    q.addEventListener('click', function () {
      var isOpen = el.classList.contains('open');
      // Chiudi tutti
      document.querySelectorAll('.faq-item.open').forEach(function (o) {
        o.classList.remove('open');
        o.querySelector('.faq-a').style.maxHeight = '0';
        var ic = o.querySelector('.faq-icon');
        if (ic) ic.textContent = '+';
      });
      // Apri/chiudi corrente
      if (!isOpen) {
        el.classList.add('open');
        a.style.maxHeight = a.scrollHeight + 'px';
        if (icon) icon.textContent = '−';
      }
    });
  });

  /* ── STICKY BUY BAR ── */
  var stickyBar = document.querySelector('.sticky-bar');
  var pdpHero   = document.querySelector('.pdp-hero');
  if (stickyBar && pdpHero) {
    window.addEventListener('scroll', function () {
      stickyBar.classList.toggle('show', pdpHero.getBoundingClientRect().bottom < 0);
    }, { passive: true });
  }

  /* ── QTY BUTTONS ── */
  document.querySelectorAll('.qty-row').forEach(function (row) {
    var input = row.querySelector('.qty-input');
    var minus = row.querySelector('.qty-minus');
    var plus  = row.querySelector('.qty-plus');
    if (!input) return;
    if (minus) minus.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      input.value = Math.max(1, v - 1);
    });
    if (plus) plus.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      input.value = v + 1;
    });
  });

});
